

































































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax';
import AbpBase from '../../../../lib/abpbase';
import BusinessField from '../../../../components/tools/businessField.vue';
import SelectPerson from "../../../../components/select/selectPerson.vue";
import SelectDep from "../../../../components/select/selectDep.vue";
import QuickTable from "../../../../components/table/table.vue";
@Component({
	name:'qualityAndSafetyManageOrg',
	components: {
		BusinessField,
		QuickTable,
		SelectPerson,
		SelectDep
	}
})
export default class QualityAndSafetyManageOrg extends AbpBase {
	initData:any = {
		showModal: false,
		showEditModal: false,
		formLoading: false,
		editFormLoading: false,
		columns: [
            {
                title: '部门（实体）',
                key: 'depDisplayName'
            },
            {
                title: '姓名',
                key: 'name'
            },
            {
                title: '质量安全管理角色',
                key: 'place'
            },
            {
                title: '分管领域',
                key: 'businessAreaDesc',
                render: (h:any, params:any) => {
                	return h('span', {
                		domProps: {
                			innerHTML: params.row.businessAreaDesc.replace(/\n/g, "<br/>")
                		}
                	})
                }
            },
            {
                title: '操作',
                render: (h:any, params:any) => {
                	return h('span', [
                		h('Button', {
                			props: {
                				type: 'success',
                				size: 'small'
                			},
							on: {
								click: () => {
									this.editForm.id = params.row.id;
									this.editForm.place = params.row.place;
									this.editForm.organizationId = params.row.depId;
									this.editForm.businessArea = params.row.businessAreaFormat;
									this.initData.showEditModal = true;
								}
							}
                		}, '编辑'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                				marginLeft: '10px'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
        ]
	}
	formData:any = {
		id: ''
	}
	editForm:any = {
		id: '',
		place: '',
		organizationId: 0,
		businessArea: []
	}
	ruleValidate:any = {
		id: [
			{ required: true, type: 'number', message: '请选择人员', trigger: 'change' }
		],
		place: [
			{ required: true, message: '请填写职（务）位', trigger: 'blur' }
		],
		organizationId: [
			{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }
		]
	}
    async GetData() {
        (this as any).$refs.table.GetData();
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此质量安全管理组织机构？',
            onOk: () => {
                Ajax.delete('/api/services/app/User/DeleteQSDepAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    // 提交
    handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	this.initData.formLoading = true;
                await Ajax.post('/api/services/app/User/CreateQSDepAsync', this.formData).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.initData.formLoading = false;
	                this.initData.showModal = false;
                	this.GetData();
	            })
            }
        })
    }
    // 编辑
    handleEditSubmit() {
    	(this.$refs.editForm as any).validate(async (valid:boolean)=>{
            if(valid){
            	let areas:any = (this as any).$refs.businessArea.GetData();
            	let params:any = {
            		id: this.editForm.id,
					place: this.editForm.place,
					organizationId: this.editForm.organizationId,
					businessArea1: areas[0],
					businessArea2: areas[1]
            	}
            	this.initData.editFormLoading = true;
                await Ajax.put('/api/services/app/User/UpdateQSDepAsync', params).then((res:any)=>{
	                this.$Message.success('编辑成功!');
	                this.initData.editFormLoading = false;
	                this.initData.showEditModal = false;
                	this.GetData();
	            }).catch(() => {
	            	this.initData.editFormLoading = false;
	            })
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		(this as any).$refs.form.resetFields();
    	}
    }
    handleClearEditForm(flog:any) {
    	if(!flog) {
    		this.initData.showEditModal = false;
    		(this as any).$refs.editForm.resetFields();
    	}
    }
}
